import { any, pick, pipe, values } from 'ramda';
import { withRGPortlet } from 'js/components/hocs/withRGPortlet';
import { componentService } from 'js/services/component.service';
import LoginLimitsForm from './LoginLimitsForm';
import { fetchLimits } from './server';
import reducer, { initialValue } from './reducer';
import { LIMIT_FIELD_NAMES, RESPONSIBLE_GAMING_LOGIN_LIMITS } from './constants';

export const isLimitEnabled = pipe(
    pick(values(LIMIT_FIELD_NAMES)),
    values,
    any(Boolean)
);

export const LoginLimits = withRGPortlet({
    forLoggedIn: true,
    reducer,
    initialValue,
    fetch: fetchLimits,

    // limits options
    isLimitEnabled
})(LoginLimitsForm);

componentService.registerPageComponents({ [RESPONSIBLE_GAMING_LOGIN_LIMITS]: LoginLimits });
